import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const DeletePhotoDialog = ({ pendingDelete, onOpenChange, onConfirm }) => (
  <AlertDialog open={!!pendingDelete} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="delete-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete this photo?</AlertDialogTitle>
        <AlertDialogDescription>
          {pendingDelete?.original_file_name
            ? `"${pendingDelete.original_file_name}" will be removed from this test record and SharePoint.`
            : "This photo will be removed from this test record and SharePoint."}{" "}
          This cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="delete-cancel-btn" className="h-11">
          Cancel
        </AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          data-testid="delete-confirm-btn"
          className="h-11 bg-[#b30035] hover:bg-[#8f002a] text-white"
        >
          Yes, delete
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
